import {Typography} from 'components/Typography';
import {useCallback} from 'react';
import style from './style.module.scss';
import {Button} from 'components/Button';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useProductBasePrice} from 'hooks/product/useProductBasePrice';
import cs from 'classnames';

interface IProductNotifyAvailabilityProps {
    withButton?: boolean;
}

export const ProductNotifyAvailability = (props: IProductNotifyAvailabilityProps) => {
    const {withButton = true} = props;

    const dispatch = useAppDispatch();
    const productData = useAppSelector(selectProductData);
    const basePrice = useProductBasePrice(productData);

    const handleClick = useCallback(() => {
        dispatch(showModal(MODALS.PRODUCT_NOTIFY_AVAILABLE.name));
    }, [dispatch]);

    return (
        <>
            <Typography className={cs(style.price, style.mobilePrice)} variant={'label-16-r'}>
                {basePrice}
            </Typography>
            <div className={style.main}>
                <Typography variant={'title-20-m'}>Этот товар закончился</Typography>
                <Typography className={style.description} element={'div'} variant={'body-14-reg'}>
                    Напишем письмо, как только товар снова поступит&nbsp;в&nbsp;продажу
                </Typography>
                {basePrice && (
                    <Typography className={style.price} variant={'label-16-r'}>
                        {basePrice}
                    </Typography>
                )}
                {withButton && (
                    <Button className={style.button} isStretched={true} onClick={handleClick} theme={'ghost'}>
                        <Typography variant={'label-16-r'}>Узнать о наличии</Typography>
                    </Button>
                )}
            </div>
        </>
    );
};
